export default new class modalForm {
  constructor() {
    this.modalOpenBtn = '_open-download-modal';
    this.modalFormSelector = '_modal-download-form';
    this.modalNameInputSelector = '_modal-download-name-input';
    this.modalEmailInputSelector = '_modal-download-email-input';
    this.modalPhoneInputSelector = '_modal-download-phone-input';
    this.modalPrivacyPolicyInputSelector = '_modal-download-privacypolicy-input';
    this.modalDownloadFilesSelector = '_files-download';
    this.submitBtnSelector = '_download-modal-submit';
    this.inValidSelector = '_invalid';
    this.successSelector = '_modal-download-success';
    this.successVisibleSelector = 'subscribe__success_visible';
    this.preLoaderSelector = '_modal-form-preloader';
    this.delay = 4000;

    this.openModal();
    this.openAutoModal();
    this.closeModal();

    $('body').on('click', `.${this.submitBtnSelector}`, () => {
      this.handler();
    });
  }

  handler() {
    const form = document.querySelector(`.${this.modalFormSelector}`);

    if (!form) return;

    setTimeout(() => {
      this.checkForm(form);
    }, 0);
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const checkboxFiles = form.querySelectorAll('input[type=checkbox]');

    const empty = [].filter.call(checkboxFiles, el => !el.checked);

    if (checkboxFiles.length === empty.length) {
      return;
    }

    const inputName = form.querySelector(`.${this.modalNameInputSelector}`);
    const name = inputName.value;

    const inputEmail = form.querySelector(`.${this.modalEmailInputSelector}`);
    const email = inputEmail.value;

    const inputPhone = form.querySelector(`.${this.modalPhoneInputSelector}`);
    const phone = inputPhone.value;

    const files = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < checkboxFiles.length; i++) {
      if (checkboxFiles[i].checked && checkboxFiles[i].name === 'files[]') {
        files[i] = checkboxFiles[i].value;
      }
    }

    // eslint-disable-next-line camelcase
    const page_url = window.location.href;

    $.request('Download::onSignup', {
      data: {
        name,
        email,
        phone,
        files,
        page_url,
      },
      complete: (res) => {
        this.showSuccess(res);
        setTimeout(() => {
          this.hideSuccess();
        }, this.delay);
      },
    });
  }

  showSuccess(res) {
    const { statusText } = res;
    if ((statusText === 'success') || (statusText === 'OK')) {
      $(`.${this.successSelector}`).addClass('show');
      $.request('onAjax', {
        update: {
          'forms/download-files/success': '._modal-download-body',
        },
        success(result) {
          this.success(result);
          // eslint-disable-next-line no-undef
          ym(71321556, 'reachGoal', 'download71321556');
        },
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  hideSuccess() {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    $('._modal-download-window').removeClass('open');
    // eslint-disable-next-line sonarjs/no-duplicate-string
    $('._modal-background').removeClass('show');
  }

  // eslint-disable-next-line class-methods-use-this
  openAutoModal() {
    const field = 'download-auto';
    const url = window.location.href;
    if (url.indexOf(`?${field}=`) !== -1) {
      $('.mobile-phone').mask('+7 (999) 999-99-99');
      $('._modal-download-window').addClass('open');
      $('._modal-background').addClass('show');
    }
  }

  openModal() {
    $(document)
      .on('click', `.${this.modalOpenBtn}`, () => {
        $('.mobile-phone').mask('+7 (999) 999-99-99');
        $('._modal-download-window').addClass('open');
        $('._modal-background').addClass('show');
      });
  }

  // eslint-disable-next-line class-methods-use-this
  closeModal() {
    $(document)
      .on('click', '._close-download-modal', () => {
        $('._modal-download-window').removeClass('open');
        $('._modal-background').removeClass('show');
      });
    $(document).on('click', '._modal-background', () => {
      $('._modal-download-window').removeClass('open');
      $('._modal-background').removeClass('show');
    });
  }
}();
